// The client side of /api/profile (BUILD-BRIEF-R3 §3, §4) — owned by the `profile-core` agent.
//
// `getRaster` answers today: the raster is a versioned document in the repo, so the console can
// render its block, cell and value labels before a single cell has been filled.
//
// THERE IS NO FILL VERB HERE (BUILD-BRIEF-R4 §6c). A raster is filled by a `deep_research` run
// started through `api/runs.startRun`; these two calls only READ.
import { request } from './client.js';
import type { ProfileResponse } from '../../shared/types.js';
import type { RasterBlock, RasterLabelSet } from '../../shared/raster.v1.js';

export interface RasterDocument {
  version: string;
  blocks: RasterBlock[];
  labels: Record<'en' | 'de' | 'fr', RasterLabelSet>;
}

/** The raster itself — blocks, cells, values and their labels in the three console languages. */
export function getRaster(): Promise<RasterDocument> {
  return request('/profile/raster');
}

/** One organisation's raster: the blocks with their cells, coverage, triggers and score. */
export function getProfile(organisationId: number): Promise<ProfileResponse> {
  return request(`/profile/${organisationId}`);
}
